import React, { FunctionComponent } from 'react'
import { Trans, useTranslation } from 'next-i18next'
import { Tag, Text, Heading } from '@afterpaytouch/core'

import { useGetOrderTransactionQuery } from '../../state'
import { Money } from '../Money'
import { OrderSnapshotLinks } from './OrderSnapshotLinks'
import { useIsAFFOrder } from '../OrderDetailPanel/hooks'

const I18N_NAMESPACE = ['common', 'orders']

interface OrderSnapshotProps {
  orderId: string
}

export const OrderSnapshot: FunctionComponent<OrderSnapshotProps> = ({ orderId }) => {
  const testNameSpace = 'order-snapshot'
  const { t } = useTranslation(I18N_NAMESPACE)
  const { data } = useGetOrderTransactionQuery(orderId)
  const { loan } = data ?? {}
  const isAFFOrder = useIsAFFOrder(orderId)

  return (
    <div data-testid={testNameSpace}>
      <div className='mb-4 lowercase'>
        {!isAFFOrder && <Tag.Primary testNameSpace={testNameSpace}>{`${String(loan?.term)} ${t('common:month', { count: loan?.term })}`}</Tag.Primary>}
      </div>
      <Heading size='XXL' renderAs='h3' testNameSpace={testNameSpace}>
        <Trans
          components={{
            amount: (
              <Money
                size='XXL'
                bold
                // @ts-ignore: OPERATION BLEED STOPPER
                value={loan?.monthlyPayment}
              />
            ),
          }}
          i18nKey='orders:orderSnapshot:paymentFrequency'
          context={isAFFOrder ? 'aff' : ''}
        />
      </Heading>
      {!isAFFOrder && (
        <Text testNameSpace={testNameSpace} renderAs='span'>
          <Trans
            values={{ percentage: loan?.effectiveApr }}
            // @ts-ignore: OPERATION BLEED STOPPER
            components={{ interest: <Money size='M' value={loan?.totalInterest} /> }}
            i18nKey='orders:orderSnapshot:rates'
          />
        </Text>
      )}
      <OrderSnapshotLinks orderId={orderId}></OrderSnapshotLinks>
    </div>
  )
}
